import React, {Component} from 'react'
import Spinner, {SpinnerContext} from "../components/YesNo/Spinner"
import ResultBlock from "../components/YesNo/ResultBlock"
import Menu from "../components/Menu";
import Banner from "../components/Banner";
import {Helmet} from "react-helmet"
import {Link} from 'react-router-dom'

class YesNoMaybe extends Component{
    constructor(props) {
        super(props);

        this.btnReset = () => {
            this.setState({
                answers: {
                    yes: 0,
                    no: 0,
                    probably: 0
                }
            })
        };

        this.btnSpin = ({speed}) => {
            if(!this.state.animate) {
                const rand = Math.round(1 + Math.random() * (8 - 1));
                const end_position = this.state.end_position + 1800 + (rand * 45);
                const answer = parseInt((end_position - (parseInt(end_position / 360) * 360)) / 45);
                this.setState({
                    animate: true,
                    start_position: this.state.end_position,
                    end_position,
                    speed,
                });
                setTimeout(
                    function () {
                        this.setState({
                            animate: false,
                            answers: {
                                yes: (answer === 1 || answer === 4 || answer === 7) ? this.state.answers.yes + 1 : this.state.answers.yes,
                                no: (answer === 0 || answer === 3 || answer === 6) ? this.state.answers.no + 1 : this.state.answers.no,
                                probably: (answer === 2 || answer === 5) ? this.state.answers.probably + 1 : this.state.answers.probably,
                            }
                        });
                    }.bind(this),
                    (10 / speed) * 1000
                );
            }
        };

        this.state = {
            animate: false,
            start_position: 22.5,
            speed: 5,
            end_position: 22.5,
            btnSpin: this.btnSpin,
            btnReset: this.btnReset,
            answers: {
                yes: 0,
                no: 0,
                probably: 0
            }
        };
    }

    render() {
        return (
            <SpinnerContext.Provider value={this.state}>
                <Helmet>
                    <title>{this.props.title}</title>
                    <meta name="description" content="Бесплатное онлайн гадание: ДА НЕТ НАВЕРНОЕ. На любовь, отношения, будущее и другие волнующие вопросы." />
                </Helmet>
                <div className="row justify-content-between content">
                    <div className="col-lg-8 col-xs-12 col-sm-12">
                        <Spinner withprobably={true} title={this.props.header || this.props.title}/>
                        <p className={"description"}>Придумайте или сконцентрируйтесь на интересующем вопросе, который волнует Вас в настоящее время. Для старта <b>подержите кнопку в центре</b> и при желании повторите процедуру. Проведите гадание да бы получить решение онлайн, в котором вы сомневаетесь. После нескольких вращений волшебного барабана вы получите варианты ответов, в том числе с процентами выпаданий. Надеемся это поможет вам принять нужный и верный шаг.</p>
                        <h2>Правдивое гадание</h2>
                        <p className={"description"}>Получение правильного ответа на заданный вопрос - цель нашего сайта. При его использовании Вы получаете максимально правдивый ответ, так как регулируете работу стрелки собственноручно. Никто кроме Вас не управляет этим процессом и не в состоянии предугадать ответ. Хотите ли вы узнать четкий ответ <Link to="/"><b>Да или НЕТ</b></Link> или более развернутый, мы гарантируем его точность и достоверность.</p>

                    </div>
                    <div className="col-lg-4 col-xs-12 col-sm-12">
                        <Menu {...{parent: {className: "main-menu"}, short: true}}/>
                        {window.innerWidth < 1048 &&
                        (<div id="ads_top_mobile">
                            <Banner currentPath={this.props.title} id={'R-A-454127-3'}/>
                        </div>)
                        }
                        <ResultBlock withprobably={true}/>

                        {window.innerWidth >= 1048 &&
                        (<div id="ads_right">
                            <a href={"/button.html"} className={"taro_bot_btn"} target={"_blank"}><div>Гадание таро телеграмм бот</div></a>
                            <img
                                alt='Доступно в Google Play'
                                src='image/qrteleg.png'
                                width='300'
                                height='300'
                                style={{
                                    width: '100%'
                                }}
                            />
                            <Banner id={'R-A-454127-2'} currentPath={this.props.title}/>
                        </div>)
                        }
                    </div>
                </div>
            </SpinnerContext.Provider>
        );
    }
}

export default YesNoMaybe